import { useState } from 'react'

import { Icon } from '../Icon'
import Button from '../app/design/Button'
import { Select } from './fields/Select'

type Props = Omit<React.ComponentProps<typeof Select>, 'trigger' | 'onOpenChange'>

export function MoreMenuButton({ options, onSelectOption, align = 'end', size = 'small' }: Props) {
    const [isOpen, setIsOpen] = useState(false)

    return (
        <Select
            size={size}
            align={align}
            options={options}
            onOpenChange={setIsOpen}
            trigger={
                <Button
                    intent="tertiary_deprecated"
                    size="small"
                    active={isOpen}
                    onClick={(e: any) => {
                        e.stopPropagation()
                    }}
                    className="p-[10px]"
                >
                    <Icon
                        icon="moreHorizontal.small"
                        shouldInheritColor
                        className="text-gray-500"
                    />
                </Button>
            }
            onSelectOption={onSelectOption}
        />
    )
}
